import React from 'react';
import { StyledError, StyledInput, StyledLabel, Wrapper } from './styles';
export const Input = ({ errorMessage = '', label = '', id = '', placeholder = '', onChangeValue = () => {
}, state = '', value = '', name = '', type = '', required = false, mask = false, dataTest = '', }) => {
    return (React.createElement(Wrapper, null,
        React.createElement(StyledInput, { id: id, placeholder: placeholder, onChange: event => onChangeValue(event.target.value), state: state, value: value, name: name, type: type, "data-cs-mask": mask, "data-test": dataTest }),
        React.createElement(StyledLabel, { state: state }, required ? (React.createElement(React.Fragment, null,
            label,
            " ",
            React.createElement("span", { style: { color: '#EF3A4C' } }, "*"))) : (label)),
        errorMessage && React.createElement(StyledError, null, errorMessage)));
};
